var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqupment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.3,17H2.7c-0.6,0-1-0.4-1-1s0.4-1,1-1h26.7c0.6,0,1,0.4,1,1S29.9,17,29.3,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.7,27.7H5.3c-1,0-1.9-0.4-2.6-1.1C2,25.9,1.7,25,1.7,24v-8c0-0.2,0-0.3,0.1-0.4l4.6-9.2 c0.3-0.6,0.8-1.1,1.4-1.5C8.3,4.5,9,4.3,9.7,4.3h12.7c0.7,0,1.4,0.2,1.9,0.6c0.6,0.4,1,0.9,1.4,1.5l4.6,9.2 c0.1,0.1,0.1,0.3,0.1,0.4v8c0,1-0.4,1.9-1.1,2.6S27.6,27.7,26.7,27.7z M3.7,16.2V24c0,0.4,0.2,0.9,0.5,1.2 c0.3,0.3,0.7,0.5,1.2,0.5h21.3c0.4,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.2v-7.8l-4.5-9c-0.1-0.3-0.4-0.5-0.6-0.7 c-0.3-0.2-0.6-0.2-0.9-0.2H9.7C9.3,6.3,9,6.4,8.8,6.6C8.5,6.7,8.3,7,8.2,7.3c0,0,0,0,0,0L3.7,16.2z M7.3,6.8L7.3,6.8L7.3,6.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,22.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S8.6,22.3,8,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,22.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S13.9,22.3,13.3,22.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqupment);
export default __webpack_public_path__ + "static/media/equpment.b55ec404.svg";
export { ForwardRef as ReactComponent };